import { render, staticRenderFns } from "./ReTaskEnds.vue?vue&type=template&id=cbba22f2&scoped=true"
import script from "./ReTaskEnds.vue?vue&type=script&lang=js"
export * from "./ReTaskEnds.vue?vue&type=script&lang=js"
import style0 from "./ReTaskEnds.vue?vue&type=style&index=0&id=cbba22f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbba22f2",
  null
  
)

export default component.exports